import { AxiosService, ResponseService } from './';

const list = async (
  _perPage,
  _page,
  _searchData,
  _sortBy,
  user_id,
  investmentType,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/owned_assets/list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        searchData: _searchData,
        sortBy: _sortBy,
        user_id: user_id,
        investmentType: investmentType,
      },
    };

    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const details = async (_projectId) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'projects/' + _projectId,
      isAuthorized: true,
    };

    const response = await AxiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const addInvestment = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/owned_assets/add_investment',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

export { list, details, addInvestment };
